import React, { useEffect } from 'react';

import Sidebar from './Sidebar'//import $ from "jquery";

import { Link } from 'react-router-dom';
import MainImg from '../assets/img/signin1.png'
import Icon1 from '../assets/img/Icons/Icons/Icon-01.png'

import Icon2 from '../assets/img/Icons/Icons/Icon-06.png'

import Icon3 from '../assets/img/Icons/Icons/Icon-02.png'
import Icon4 from '../assets/img/Icons/Icons/Icon-07.png'

import Icon5 from '../assets/img/Icons/Icons/Icon-03.png'
import Icon6 from '../assets/img/Icons/Icons/Icon-08.png'


import Icon7 from '../assets/img/Icons/Icons/Icon-04.png'
import Icon8 from '../assets/img/Icons/Icons/Icon-09.png'

import Icon9 from '../assets/img/Icons/Icons/Icon-05.png'
import Icon10 from '../assets/img/Icons/Icons/Icon-10.png'

import Barside from '../assets/img/Icons/Icons/Icon-17.png'
import Footer from '../pages/footer'
import RedL from '../assets/img/Icons/Icons/red.png'
const Location = () => {


    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [])


    return (
        <div>
            <div className="bg-white border shadow  bg-bottom-round">
                <div className="container page17">
                    <div className="row mt-3">
                        <div className="col-sm-1-my17 ">
                            <Sidebar/>
                        </div>
                        <div className="col-sm-11-my17 text-center ">

                            <h5 className=" signin1-h1-top  mb-0">Location</h5>
                        </div>

                    </div>

                    <div className="row page17-p">
                        <div className="col-sm-12 py-2">
                            <hr className="mt-2" />

                            <div className=" row px-3">
                                <div className="col-sm-11-LSB">
                                    <div className="bg-white input-group location-input-group  input-group-L mb-3" >
                                        <div className=" input-group-prepend ">
                                            <span className="input-group-text border-right-0" id="basic-addon1"><i className="fa fa-search" aria-hidden="true"></i></span>
                                        </div>
                                        <input type="text" className="form-control border-left-0 " placeholder="Zip code or City" aria-label="Username" aria-describedby="basic-addon1" />
                                    </div>
                                </div>

                                <div className="col-sm-1-LSB">
<img src={RedL} alt=""className="RedL" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="bg-light rounded-lg p-3 L-card mt-2">
                                        <h5 className="fw500 mb-1">1234 Test Street</h5>
                                        <p className="mb-1"><small className="mb-0 fw600 text-secondary-light-gray">City: State, Zip</small></p>
                                        <p className="fw500 mb-0 phone-L">Phone :13255 54685</p>
                                    </div>
                        
                                    <div className="bg-light rounded-lg p-3 L-card mt-2">
                                        <h5 className="fw500 mb-1">1234 Test Street</h5>
                                        <p className="mb-1"><small className="mb-0 fw600 text-secondary-light-gray">City: State, Zip</small></p>
                                        <p className="fw500 mb-0 phone-L">Phone :13255 54685</p>
                                    </div>
                        
                                    <div className="bg-light rounded-lg p-3 L-card mt-2">
                                        <h5 className="fw500 mb-1">1234 Test Street</h5>
                                        <p className="mb-1"><small className="mb-0 fw600 text-secondary-light-gray">City: State, Zip</small></p>
                                        <p className="fw500 mb-0 phone-L">Phone :13255 54685</p>
                                    </div>
                        
                                    <div className="bg-light rounded-lg p-3 L-card mt-2">
                                        <h5 className="fw500 mb-1">1234 Test Street</h5>
                                        <p className="mb-1"><small className="mb-0 fw600 text-secondary-light-gray">City: State, Zip</small></p>
                                        <p className="fw500 mb-0 phone-L">Phone :13255 54685</p>
                                    </div>
                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Location;

